﻿(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Factories").factory("RangeImageApi", [
    "$filter",
    "API",
    "DebugLogger",
    function ($filter, API, DebugLogger) {
      function getHeroByMaterialCode(materialCode) {
        return API.get(
          $filter("formatArgs")(ToyotaConsts.API.Vehicle.ImageHero, [
            materialCode,
          ])
        ).then(function (response) {
          if (!response.data.success) {
            DebugLogger.log(
              "RangeImageApi",
              "getHeroByMaterialCode: server responded with falsy success"
            );
            throw new Error(
              "RangeImageApi.getHeroByMaterialCode: server responded with falsy success"
            );
          }

          return response.data;
        });
      }

      return {
        getHeroByMaterialCode: getHeroByMaterialCode,
      };
    },
  ]);
})(window.angular, window.ToyotaConsts);
